import template from './customer_not_associated.html';
import controller from './customer_not_associated.controller';
import './customer_not_associated.scss';

let CustomerNotAssociatedComponent = {
  restrict: 'E',
  template,
  controller
};

export default CustomerNotAssociatedComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/customer_not_associated/customer_not_associated.component.js